import React from 'react'
import { cn } from 'lib/utils'

export interface Props {
	className?: string
	children: React.ReactNode
}

/**
 * The frame around a project, portfolio or location conversation.
 *
 * Styled to match the global chat panel — same 2xl radius, same hairline
 * border, white ground, clipped content — so the two chats read as one system.
 * The size is unchanged: it still fills whatever the asset page's tab gives it,
 * which is what `flex-1 h-full` did before.
 *
 * Replaces the styled-components ChatWindow, whose fixed 16px/24px padding
 * fought the composer's own padding and left the messages inset from the frame
 * by a different amount than the input.
 */
const RoomChatWindow = ({ className = '', children }: Props) => (
	<div
		data-testid="room-chat-window"
		className={cn(
			'flex h-full min-h-0 flex-1 flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl',
			className,
		)}
	>
		{children}
	</div>
)

export default RoomChatWindow
